<template>
  <specialisation-form
    v-model="form"
    :site-context-options="site_context_options"
    class="w-[720px] max-w-[92vw] bg-gray-50"
    @submit="submit"
  >
    <div
      class="flex items-center justify-end px-6 pb-6"
    >
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
      >
        Utwórz specjalizację
      </loading-button>
    </div>
  </specialisation-form>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useForm } from '@inertiajs/vue3';
import LoadingButton from '@/Shared/LoadingButton.vue';
import SpecialisationForm from './Form.vue';
import { createSpecialisationRouteHelper } from '@/utils/createSpecialisationRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

defineProps({
  // eslint-disable-next-line vue/prop-name-casing
  site_context_options: {
    type: Array,
    default: () => [],
  },
});

const form = useForm({
  specialisation: {
    active: true,
    use_local_name: false,
    site_context: 'code_medical_center',
    data_pl: { name: '', remote_name: '', description: '', faq: [] },
    data_en: { name: '', remote_name: '', description: '', faq: [] },
  },
});

const specialisationRoutes = computed(() => {
  return createSpecialisationRouteHelper(null, routes);
});

const emit = defineEmits(['success']);

const submit = () => {
  form.post(specialisationRoutes.value.index(), {
    onFinish: () => {
      if (!form.hasErrors) {
        form.reset();
        form.specialisation.active = true;
        form.specialisation.site_context = 'code_medical_center';
      }
    },
    onSuccess: () => {
      emit('success');
    },
    onError: () => {},
  });
};
</script>
